var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.1 40.1C76.1 20.2 60 4.09998 40.1 4.09998C20.2 4.09998 4.10001 20.2 4.10001 40.1C4.10001 60 20.2 76.1 40.1 76.1C60 76.1 76.1 60 76.1 40.1ZM7.40001 40.1C7.40001 22 22.1 7.39998 40.1 7.39998C58.1 7.39998 72.8 22.1 72.8 40.1C72.8 58.1 58.2 72.8 40.1 72.8C22 72.8 7.40001 58.2 7.40001 40.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 31.9999H22.9V60.2999H31V31.9999Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 19.9H22.9V28H31V19.9Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3 60.2999H51.2V44.1999C51.2 41.9999 49.4 40.1999 47.2 40.1999C45 40.1999 43.2 41.9999 43.2 44.1999V60.3999H35.1V31.9999H43.2V33.4999C45.3 32.7999 46.7 31.9999 49.3 31.9999C54.8 31.9999 59.4 36.8999 59.4 42.6999L59.3 60.2999Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLinkedin);
export default __webpack_public_path__ + "static/media/footer-linkedin.1f3da762.svg";
export { ForwardRef as ReactComponent };